import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex lg:items-center md:items-center items-start justify-between mb-1" }
const _hoisted_3 = { class: "font-bold lg:mr-0 md:mr-0 mr-2 break-all lg:w-auto md:w-auto w-auto flex-1 noresi" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "flex items-center lg:w-auto md:w-auto w-auto cursor-pointer" }, [
  /*#__PURE__*/_createVNode("i", { class: "pi pi-ellipsis-h lg:flex md:flex hidden" }),
  /*#__PURE__*/_createVNode("i", { class: "pi pi-arrow-right lg:hidden md:hidden" })
], -1)
const _hoisted_5 = { class: "flex items-center justify-between mb-2" }
const _hoisted_6 = { class: "detail-route flex items-center" }
const _hoisted_7 = { class: " px-2 rounded-md lg:text-sm md:text-sm text-xs" }
const _hoisted_8 = { class: "flex flex-row items-center justify-between pt-2" }
const _hoisted_9 = { class: "flex flex-row justify-between lg:items-center md:items-center items-start lg:w-auto md:w-auto w-full md:divide-x md:divide-green-500" }
const _hoisted_10 = { class: "flex md:w-auto md:mr-2" }
const _hoisted_11 = { class: "lg:px-1 my-1 lg:w-auto px-1" }
const _hoisted_12 = {
  class: "px-2 inline-block rounded-md font-semibold text-base color-green-darken-1",
  style: {"background-color":"#E8F5E9","color":"rgb(84, 110, 122)","border":"1px solid rgb(67, 160, 71)"}
}
const _hoisted_13 = { class: "lg:px-1 my-1 lg:w-auto px-1" }
const _hoisted_14 = {
  class: "px-2 inline-block rounded-md font-semibold text-base",
  style: {"background-color":"rgb(236, 239, 241)","color":"rgb(84, 110, 122)","border":"1px solid rgb(84, 110, 122)"}
}
const _hoisted_15 = {
  key: 0,
  class: "lg:w-auto mx-2 lg:px-2 sm:my-2"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "pi pi-clock " }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Belum diproses ")
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "lg:flex md:flex hidden cursor-pointer my-2 lg:my-1" }, [
  /*#__PURE__*/_createVNode("p", { class: "color-primary" }, [
    /*#__PURE__*/_createTextVNode("Proses Pendapatan "),
    /*#__PURE__*/_createVNode("i", { class: "pi pi-chevron-right " })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")

  return (_ctx.item)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode(_component_Card, {
          class: `cursor-pointer card-no-shadow mt-2 card-item-category ${(_ctx.item.StatusPengirimanId === 6) ? 'background-grey-lighten-5': ''}`,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDetail(_ctx.item.TransJadwalHdId)))
        }, {
          content: _withCtx(() => [
            _createVNode("div", _hoisted_2, [
              _createVNode("h5", _hoisted_3, _toDisplayString(_ctx.item.KodeJadwal), 1),
              _hoisted_4
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("span", _hoisted_7, _toDisplayString(_ctx.moment(_ctx.item.TanggalAktif).format('DD MMMM YYYY')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _createVNode("div", _hoisted_10, [
                  _createVNode("div", _hoisted_11, [
                    _createVNode("p", _hoisted_12, _toDisplayString(_ctx.item.Rit?`Rit ${_ctx.item.Rit}`:''), 1)
                  ]),
                  _createVNode("div", _hoisted_13, [
                    _createVNode("p", _hoisted_14, _toDisplayString(_ctx.item.Kode), 1)
                  ])
                ]),
                ((_ctx.item.IsClose === false))
                  ? (_openBlock(), _createBlock("div", _hoisted_15, [
                      _hoisted_16,
                      _hoisted_17
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_18
            ])
          ]),
          _: 1
        }, 8, ["class"])
      ]))
    : _createCommentVNode("", true)
}